import { getModuleDetails } from '../moduleDetails'

describe('getModuleDetails', () => {
  it('groups valves and sensor values by module', () => {
    const details = getModuleDetails(
      7,
      [
        { id: 1, wateringModuleId: 7 },
        { id: 2, wateringModuleId: 8 },
      ],
      [
        { id: 3, wateringModuleId: 7 },
        { id: 4, wateringModuleId: 8 },
      ]
    )

    expect(details).toEqual({
      valves: [{ id: 1, wateringModuleId: 7 }],
      sensorValues: [{ id: 3, wateringModuleId: 7 }],
    })
  })

  it('returns empty collections when resources are not loaded', () => {
    expect(getModuleDetails(7)).toEqual({ valves: [], sensorValues: [] })
  })
})
